(function (e, t) {
    var n, o, d, i, s, a = [], r = document.createElement("iframe");

    window.zEmbed = function () {
        a.push(arguments);
    };

    window.zE = window.zE || window.zEmbed;

    r.src = "about:blank";
    r.title = "";
    r.role = "presentation";
    r.style.cssText = "display: none";

    d = document.getElementsByTagName("script");
    d = d[d.length - 1];
    d.parentNode.insertBefore(r, d);

    i = r.contentWindow;
    s = i.document;

    try {
        o = s;
    } catch (e) {
        n = document.domain;
        r.src = `javascript:var d=document.open();d.domain="${n}";void(0);`;
        o = s;
    }

    const initializeScript = function () {
        var script = o.createElement("script");
        if (n) {
            o.domain = n;
        }
        script.id = "js-iframe-async";
        script.src = "https://assets.zendesk.com/embeddable_framework/main.js";
        o.t = +new Date;
        o.zendeskHost = "uppababy.zendesk.com";
        o.zEQueue = a;
        o.body.appendChild(script);
    };

    // Safely construct the iframe content without `document.write`.
    o.open();
    const html = o.createElement("html");
    const body = o.createElement("body");
    html.appendChild(body);
    o.appendChild(html);
    body.onload = initializeScript; // Set the `onload` on the body.
    o.close();
})();
